import * as React from 'react';

import { NoteView } from '@ndvr/customer-api';

import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Toast } from '@/widgets';

import { useDeleteNoteMutation } from './note-queries';

export interface DeleteHouseholdNoteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSuccess?: () => void;
    note: NoteView;
}

export const DeleteHouseholdNoteDialog = (props: DeleteHouseholdNoteDialogProps) => {
    const deleteMutation = useDeleteNoteMutation(props.note.householdGUID);

    const handleConfirm = () => {
        if (!props.note?.noteGUID) return;
        deleteMutation.mutate(props.note.noteGUID, {
            onSuccess: () => {
                Toast.success(`Note "${props.note.subject?.slice(0, 20) || 'Untitled note'}" deleted successfully`);
                props.onOpenChange(false);
                props.onSuccess?.();
            },
            onError: (error) => {
                Toast.forError(error, `Failed to delete note "${props.note.subject?.slice(0, 20) || 'Untitled note'}"`);
            },
        });
    };

    return (
        <Dialog open={props.open} onOpenChange={props.onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Note</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete note &ldquo;
                        {props.note.subject || props.note.content || 'Untitled note'}&rdquo;? This action cannot be
                        undone.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => props.onOpenChange(false)}
                        disabled={deleteMutation.isPending}
                    >
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={handleConfirm} disabled={deleteMutation.isPending}>
                        {deleteMutation.isPending ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
